import { useTranslation } from 'react-i18next';
import CancelTargetInfo from '@/components/Approval/@components/CancelTargetInfo';
import type { CancelTargetSnapshot } from '@/utils/approval/cancelApproval';
import { FieldBlock, FieldHeader } from '../styles';
import useCancelTargetField from './useCancelTargetField';
import { InfoSectionTitle } from '@/components/Approval/@components/InfoSection';

type CancelTargetFieldProps = {
  apvType: number;
  /** 진입 쿼리 `doc` 의 원 품의 문서번호 — 신규 작성 전용 */
  entryDocId?: string;
  /** 편집 진입 복원값(단건조회 attributes) */
  initialTarget?: CancelTargetSnapshot | null;
  isEditMode: boolean;
};

/**
 * 근태 취소 품의 「취소할 품의」 필드 — 본문 위. 표시는 조회 슬롯과 같은 CancelTargetInfo.
 * 선택 UI 없음: 대상은 진입 URL 로만 정해지고, 없거나 맞지 않으면 안내 문구만 보임(레거시 동일).
 * 「결재 종료된 품의만 취소 신청 가능」 참고 문구는 양식 가이드(GuideTemplate)가 그림 — 여기서 중복 출력 안 함
 */
const CancelTargetField = ({
  apvType,
  entryDocId,
  initialTarget,
  isEditMode,
}: CancelTargetFieldProps) => {
  const { t } = useTranslation();
  const { cancelTarget, message } = useCancelTargetField({
    apvType,
    entryDocId,
    initialTarget,
    isEditMode,
  });

  return (
    <FieldBlock>
      <FieldHeader>
        <InfoSectionTitle>{t('취소할 품의')}</InfoSectionTitle>
      </FieldHeader>
      <CancelTargetInfo target={cancelTarget} message={message} showLink />
    </FieldBlock>
  );
};

export default CancelTargetField;
